import { IReportService } from "../../service/report/ReportService";

export default class GetReport2DataInteractor {
  private reportService: IReportService;

  constructor(reportService) {
    this.reportService = reportService;
  }

  async execute(
    periodFrom: Date,
    periodTo: Date,
    min: number,
    max: number,
    evaluationStatus?: string
  ) {
    return this.reportService.getReport2Data(
      periodFrom,
      periodTo,
      min,
      max,
      evaluationStatus
    );
  }
}
